(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/collections/participated-draws.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/collections/participated-draws.js'); 
'use strict';

svs.competition.core.collections.ParticipatedDraws = Backbone.Collection.extend(
  {
    model: svs.competition.core.models.ParticipatedDraw,
    url: function() {
      return (
        svs.core.jupiter.url() +
        '/player/competitions/' +
        this.competitionId +
        '/drawstatus'
      );
    },
    initialize: function(data, options) {
      this.competitionId = options.competitionId;
      if (!options.competitionId) {
        this.model = undefined;
        return;
      }
      var self = this;

      svs.events.subscribe('/tipset/paySucess', function(event) {
        self.add(
          new svs.competition.core.models.ParticipatedDraw(event.drawNumber)
        );
      });

      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        if (options.participatedDraws) {
          this.reset(options.participatedDraws, { parse: true });
        } else {
          this.fetch();
        }
      }
    },

    parse: function(data) {
      if (!data.error) {
        return data.participatedDraws || data;
      }
      svs.competition.core.logger.error(
        'Error parsing participatedDraws. ' + data.error
      );
    },

    userHasPlayedDraw: function(drawNumber) {
      return (
        this.where({
          drawNumber: drawNumber
        }).length > 0
      );
    }
  }
);

 })(window);